import React, { useState } from 'react';
import { X, Menu } from 'lucide-react';
import { cn } from '../../lib/utils';

interface MobileMenuProps {
  children: React.ReactNode;
}

export function MobileMenu({ children }: MobileMenuProps) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    // Prevent body scroll when menu is open
    if (!isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  };

  const closeMenu = () => {
    setIsOpen(false);
    document.body.style.overflow = '';
  };

  return (
    <>
      {/* Hamburger Button - Touch-friendly 44x44px minimum */}
      <button
        onClick={toggleMenu}
        className="mobile-menu-toggle"
        aria-label="Toggle menu"
        aria-expanded={isOpen}
      >
        {isOpen ? (
          <X className="w-6 h-6" strokeWidth={2} />
        ) : (
          <Menu className="w-6 h-6" strokeWidth={2} />
        )}
      </button>

      {/* Overlay */}
      {isOpen && (
        <div
          className="mobile-menu-overlay"
          onClick={closeMenu}
          aria-hidden="true"
        />
      )}

      {/* Menu Panel */}
      <div
        className={cn(
          'mobile-menu-panel',
          isOpen && 'mobile-menu-panel-open'
        )}
      >
        <div className="mobile-menu-content">
          {React.Children.map(children, (child) => {
            if (React.isValidElement(child)) {
              const childElement = child as React.ReactElement<{ onClick?: () => void }>;
              const existingOnClick = childElement.props?.onClick;
              
              return React.cloneElement(childElement, {
                onClick: () => {
                  closeMenu();
                  if (existingOnClick) {
                    existingOnClick();
                  }
                },
              });
            }
            return child;
          })}
        </div>
      </div>
    </>
  );
}

